import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { CheckoutInformationDto, CircularChartCountDto, DashboardCustomizationLicenseDto, DashboardIssuancePerItemDateRange, DashboardMinMaxItemDto, GeneralChartDto, GeneralChartOptionDto, GeneralChartPageDto, StockCycleCountGridDto, StockLifecycleDto } from '~/models/modules/dashboard';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { StockGeneralChartTypeEnum } from '~/shared/enums/stock-general-chart-type.enum';

@Injectable({ providedIn: 'root' })
export class DashboardsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }
  private value: string = '';

  setValue(val: string) {
    this.value = val;
  }

  getValue(): string {
    return this.value;
  }

  getDashboards() {
    return this.http.get<string>(this._url());
  }
  getStockDashboards() {
    return this.http.get<string>(this._url(`/GetDashboardStock`));
  }

  getCustomizationLicense() {
    return this.http.get<DashboardCustomizationLicenseDto>(this._url(`/customization-license`));
  }

  getIssuancePerItem(model: DashboardIssuancePerItemDateRange): Observable<string> {
    return this.http.post<string>(this._url(`/issuanceperitem`), model);
  }

  getBurnRateData() {
    return this.http.get<string>(this._url(`/burnrate`));
  }

  getStockLifecycle() {
    return this.http.get<StockLifecycleDto>(this._url(`/stock-lifecycle`));
  }

  getCycleCounts() {
    return this.http.get<StockCycleCountGridDto[]>(this._url(`/grids/cycle-counts`));
  }

  getGeneralChart(graphId: StockGeneralChartTypeEnum | number, top?: number, pageName?: string) {
    let params: any = {};
    if (top) params.top = top;
    if (pageName) params.pageName = pageName;
    return this.http.get<GeneralChartDto[]>(this._url(`/general-charts/${graphId}`), { params });
  }

  getGeneralChartOptions(formName?: string) {
    let params: any = {};
    if (formName) params.formName = formName;
    return this.http.get<GeneralChartOptionDto[]>(this._url(`/general-chart-options`), { params });
  }

  getGeneralChartPages() {
    return this.http.get<GeneralChartPageDto[]>(this._url(`/general-chart-pages`));
  }

  getMinMaxItem() {
    return this.http.get<DashboardMinMaxItemDto[]>(this._url(`/min-max-item`));
  }

  getStatisticsDataReportAsync() {
    return this.http.get<any>(this._url(`/statistics-items`));
  }

  getStatisticsAssetsDataReportAsync() {
    return this.http.get<any>(this._url(`/statistics-assets`));
  }

  addMinMaxItem(ids: number[]) {
    return this.http.post<any>(this._url(`/min-max-item`), ids);
  }

  deleteMinMaxItem(id: number) {
    return this.http.delete<any>(this._url(`/min-max-item/${id}`));
  }

  updateDashboardPreference(model: any) {
    return this.client.put<string>(this._url(), model);
  }

  getCircularChartCounts(widgetname: string, widgetcategory?: string, userrole?: string): Observable<CircularChartCountDto[]> {
    let params: any = { widgetname };
    if (widgetcategory) params.widgetcategory = widgetcategory;
    if (userrole) params.userrole = userrole;
    return this.http.get<CircularChartCountDto[]>(this._url(`/circular-chart-counts`), { params });
  }

  getCheckoutInformation(): Observable<CheckoutInformationDto> {
    return this.http.get<CheckoutInformationDto>(this._url(`/checkout-information`));
  }

  getLocationItemsOverThreshold(): Observable<any> {
    return this.http.get<any>(this._url(`/location-items-over-threshold`));
  }

  getGridPanelData(panelType: string, params?: any): Observable<any> {
    return this.http.get<any>(this._url(`/grids/${panelType}`), { params });
  }

  getGridFilterOptions(filterType: string): Observable<any[]> {
    return this.http.get<any[]>(this._url(`/grids/filters/${filterType}`));
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Dashboards${v}`);
  }
}
